import React from 'react';
import { Typography, Button } from 'antd';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const { Title, Paragraph } = Typography;

const Home = () => {
  const { t } = useTranslation();

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '80vh',
        textAlign: 'center',
        padding: '20px',
      }}
    >
      {/* 添加 logo，从 public 文件夹加载 */}
      <img
        src="KasKeeper_Logo.png" // 直接使用 public 文件夹中的路径
        alt="KasKeeper Logo"
        style={{
          width: '200px', // 设置 logo 宽度，可以根据需要调整
          marginBottom: '20px', // 与下方文字保持间距
        }}
      />
      <Title level={1} style={{ color: '#00c4b4' }}>
        {t('home.title')}
      </Title>
      <Paragraph style={{ maxWidth: '600px', fontSize: '16px' }}>
        {t('home.description')}
      </Paragraph>
      <Button style={{ marginTop: '20px', backgroundColor: '#fff', borderColor: '#00c4b4', width: "150px" }}
        size='large'>
        <Link to="/privacy-policy">{t('home.privacyButton')}</Link>
      </Button>
      <Button type="primary" style={{ marginTop: '20px', backgroundColor: '#00c4b4', borderColor: '#00c4b4', width: "150px" }}
        size='large'>
        <Link to="https://chromewebstore.google.com/detail/kaskeeper/bicbpicnddlclhekbmgafcbkemdikdem?authuser=0&hl=en-GB">{t('home.getWalletButton')}</Link>
      </Button>

    </div>
  );
};

export default Home;